/**
 * PasswordFeedback Directive
 */
(function (itxApp) {

    'use strict';

    angular.module('itxApp.common')
        .directive('itxTogglePassword', ItxTogglePasswordDrt);

    /**
     * Directive for showing or hiding passwords
     */
    function ItxTogglePasswordDrt() {
        return {
            restrict: 'E',
            scope: {
                label: '@'
            },
            link: function (scope, element) {
                var $formGroup = element.closest('.form-input-label'),
                    $input = $formGroup.find('#password'),
                    currentAttr = 'password',
                    $i = element.find('i');

                $i.on('click', function () {
                    if (currentAttr === 'password') {
                        currentAttr = 'text';
                    } else {
                        currentAttr = 'password';
                    }

                    $input.attr('type', currentAttr);
                    $i.toggleClass('icon-m-contrasena-ver');
                    $i.toggleClass('icon-m-contrasena-ocultar');
                });

            },
            template: '<i class="text-right form-text form-control-feedback form-control-feedback-password icon icon-m-contrasena-ver"></i>'
        };
    }

    /** Public */
    itxApp.common.ItxTogglePasswordDrt = ItxTogglePasswordDrt;

})(window.itxApp);
